import { notificationsMixin } from './notifications';
import { methodsMixin } from './methods';

/**
 *  Mixin do zarządzania modalem edycji
 *  Zawiera pola
 *  - `idToEdit` - identyfikator edytowanego obiektu
 *  - `showModal` - czy pokazać modal dodawania / edycji
 *  Zawiera metody
 *  - `showEditModal(id)` - wyświetla modal edycji encji
 *  - `showAddModal()` - wyświetla modal dodania encji
 *  - `hideModal()` - ukrywa modal edycji/dodania
 *  - `update(data)` - aktualizuje encję
 *  - `add(data)` - dodaje encję

 *
 * @export
 * @param {*} moduleName - nazwa modułu store
 * @param {*} messages  - obiekt z wiadomościami do wyświetlenia po wykonaniu akcji i w przypadku niepowodzenia
 * @param {string} messages.getError - wiadomość w przypadku niepowodzenia przy pobieraniu encji
 * @param {string} messages.updated - wiadomość po aktualizacji encji
 * @param {string} messages.updateError - wiadomość w przypadku niepowodzenia przy aktualizacji encji
 * @returns
 */
export function modalMixin(moduleName, messages) {
  return {
    mixins: [notificationsMixin, methodsMixin],
    /**
     * Dane modułu
     *
     * @returns
     */
    data() {
      return {
        moduleName,
        idToEdit: undefined,
        showModal: false
      };
    },
    methods: {
      /**
       * Otwiera modal do edycji encji
       *
       * @param {*} id
       */
      showEditModal(id) {
        this.idToEdit = id;
        this.$store
          .dispatch(`${moduleName}/get`, id)
          .then(() => this.showAddModal())
          .catch(err => this.notifyError(messages.getError));
      },
      /**
       * Otwiera modal do dodania encji
       */
      showAddModal() {
        this.showModal = true;
      },
      /**
       * Ukrywa modal dodawania/edycji
       */
      hideModal() {
        this.$set(this, 'showModal', false);
        this.$set(this, 'idToEdit', undefined);
      },
      /**
       * Zapisuje encję
       *
       * @param {*} data
       */
      add(data) {
        return this.$store
          .dispatch(`${moduleName}/add`, this.deepClone(data))
          .then(() => {
            this.notifySuccess(messages.added);
            this.hideModal();
          })
          .catch(err => {
            err.graphQLErrors[0]
              ? this.notifyError(messages.addError, [err.graphQLErrors[0].message])
              : this.notifyError(messages.addError);
          });
      },
      /**
       * Aktualizuje encję
       *
       * @param {*} data
       */
      update(data) {
        return this.$store
          .dispatch(`${moduleName}/update`, this.deepClone(data))
          .then(() => {
            this.notifySuccess(messages.updated);
            this.hideModal();
          })
          .catch(err => this.notifyError(messages.updateError));
      }
    }
  };
}
